/**
 * Feedback.ts
 *
 * Module for payload transport.
 */
import * as Utils from "./../Utils";
import * as Logging from "./../Logging/Logging";
import * as Petrol from "./Petrol";
import { Screenshot } from "./Files/Screenshot";
import * as Configuration from "../Configuration/Configuration";
import { Manifest } from "./Files/Manifest";
export class Transporter {
  constructor(environment, manifestType, appId, type, applicationGroup, telemetryGroup, webGroup) {
    this.clientFeedbackId = Utils.guid();
    this.manifest = new Manifest(manifestType, appId, new Date().toISOString(), type, this.clientFeedbackId, Object.assign({}, applicationGroup), Object.assign({}, telemetryGroup), Object.assign({}, webGroup));
    this.environment = environment;
  }
  getClientFeedbackId() {
    return this.clientFeedbackId;
  }
  setComment(comment) {
    this.manifest.setComment(comment);
  }
  setEmail(email) {
    this.manifest.setEmail(email);
  }
  setCategory(category) {
    this.manifest.setCategory(category);
  }
  setScreenshot(screenshot) {
    this.screenshot = new Screenshot(screenshot);
  }
  getManifest() {
    return this.manifest;
  }
  /**
   * Set freeform custom values in manifest. Throws if values are already set.
   * @param values the values as a JS object
   */
  setManifestValues(values) {
    this.manifest.setValues(values);
  }
  /**
   * Submit the payload
   */
  submit() {
    if (!Configuration.get().isFeedbackSurveyEnabledByAADC()) {
      Logging.getLogger().logEvent(Logging.EventIds.Shared.Upload.Prevented.VALUE, 2 /* Error */, {
        Data: JSON.stringify({
          ageGroup: Configuration.get().getCommonInitOptions().ageGroup,
          authenticationType: Configuration.get().getCommonInitOptions().authenticationType
        })
      });
      return Promise.resolve();
    }
    let manifestContent = this.manifest.getContent();
    let screenshotContent = undefined;
    const clientFeedbackId = this.clientFeedbackId;
    if (this.screenshot) {
      screenshotContent = this.screenshot.getContent();
    }
    return Petrol.send(this.environment === 0 /* Production */, manifestContent, screenshotContent).catch(function onRejected(err) {
      Configuration.get().getCommonInitOptions().onError("Payload submission failed: " + err.message + ". ClientFeedbackId: " + clientFeedbackId);
      Logging.getLogger().logEvent(Logging.EventIds.Shared.Upload.Failed.VALUE, 2 /* Error */, {
        ErrorMessage: err.message,
        ClientFeedbackId: clientFeedbackId
      });
    });
  }
}